import styledComponent, { ThemedStyledFunction, keyframes } from 'styled-components';
import { ResolveCommonStyles } from './styles-constants';

export const component = styledComponent;

interface CustomThemedStyledFunction<P, T, O> extends ThemedStyledFunction<P, T, O> {
	withConfig: Function;
}

/* This function can be use to provide props to a styled element
 * https://github.com/styled-components/styled-components/issues/630
 */
export const styled = <U>() =>
	<P, T, O>(styledFunction: ThemedStyledFunction<P, T, O>, className: string): ThemedStyledFunction<P & U, ResolveCommonStyles, O & U> => {
		let result;
		if (process.env.NODE_ENV === 'production') {
			result = styledFunction;
		} else {
			result = (<CustomThemedStyledFunction<P, T, O>> styledFunction).withConfig({ displayName: className });
		}
		return result.attrs({ className });
	};

export const hexToRgba = (color: string, opacity: number): string => {
	const hexToR = parseInt(color.substring(1, 3), 16);
	const hexToG = parseInt(color.substring(3, 5), 16);
	const hexToB = parseInt(color.substring(5, 7), 16);
	const alpha = (opacity / 100).toPrecision(2);

	return `rgba(${hexToR}, ${hexToG}, ${hexToB}, ${alpha})`;
};

export const spin = keyframes`
	0% {
		transform: rotate(0deg);
	}

	100% {
		transform: rotate(360deg);
	}
`;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/style.ts